import {createContext} from "react";
import {UserSessionControl} from "../entities/UserSessionControl";

const UserSessionControlContext = createContext<UserSessionControl | null>(null)

export default UserSessionControlContext